export { default } from 'rmc-date-picker/lib/locale/zh_CN';



/** WEBPACK FOOTER **
 ** ./components/date-picker/locale/zh_CN.tsx
 **/